import { buildCollection, buildProperty } from "@firecms/core";
import { HomeButton } from "../components/HomeButton";

export type BadgeImage = {
    badge_id: string;
    badge_name: string;
    image_url: string;
    updated_at: Date;
    updated_by: string;
};

export const badgeImagesCollection = buildCollection<BadgeImage>({
    id: "badge_images",
    name: "Badge Images",
    singularName: "Badge Image",
    path: "badge_images",
    icon: "Image",
    group: "NFT",
    Actions: HomeButton,
    description:
        "Upload images for badge NFTs. Use the badge_id as the document ID (e.g. streak_7, cefr_b1).",
    permissions: {
        edit: true,
        create: true,
        delete: true,
    },
    properties: {
        badge_id: buildProperty({
            name: "Badge ID",
            dataType: "string",
            validation: { required: true },
            description:
                "Must match a badge ID from the registry (e.g. streak_7, sessions_100, cefr_b1, early_adopter)",
        }),
        badge_name: buildProperty({
            name: "Badge Name",
            dataType: "string",
            validation: { required: true },
            description: "Display name shown on the NFT",
        }),
        image_url: buildProperty({
            name: "Badge Image",
            dataType: "string",
            storage: {
                storagePath: "badge_images",
                acceptedFiles: ["image/png", "image/jpeg", "image/svg+xml", "image/webp"],
                maxSize: 5 * 1024 * 1024,
                storeUrl: true,
            },
            validation: { required: true },
            description: "Square image recommended (1080×1080). Will be used as the NFT image on-chain.",
        }),
        updated_at: buildProperty({
            name: "Updated At",
            dataType: "date",
            mode: "date_time",
            autoValue: "on_update",
        }),
        updated_by: buildProperty({
            name: "Updated By",
            dataType: "string",
            readOnly: true,
        }),
    },
    propertiesOrder: ["badge_id", "badge_name", "image_url", "updated_at", "updated_by"],
});
